import { popupConstants } from '../constants';
import { popupService } from '../services';
import { showToast } from '../services/toast';

export const popupActions = {
    fetchPopupMessages,
    createPopup,
    updatePopup,
    deletePopup
};

function fetchPopupMessages() {
    return dispatch => {
        dispatch(request());

        popupService.fetchPopupMessages()
            .then(
                response => {
                    dispatch(success(response.data));
                    return response;
                },
                error => {
                    dispatch(failure(error));
                    if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
                }
            );
    };

    function request() { return { type: popupConstants.FETCH_POPUPS_REQUEST } }
    function success(popups) { return { type: popupConstants.FETCH_POPUPS_SUCCESS, popups } }
    function failure(error) { return { type: popupConstants.FETCH_POPUPS_FAILURE, error } }
}

function createPopup(popupDetails) {
    return dispatch => {
        dispatch(request());

        return popupService.createPopup(popupDetails)
            .then(
                response => {
                    dispatch(success(response.data));
                    showToast(response.responseMessage, 'success');
                },
                error => {
                    dispatch(failure(error.toString()));
                    if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
                    return Promise.reject(error);
                }
            );
    };

    function request() { return { type: popupConstants.CREATE_POPUP_REQUEST } }
    function success(popups) { return { type: popupConstants.CREATE_POPUP_SUCCESS, popups } }
    function failure(error) { return { type: popupConstants.CREATE_POPUP_FAILURE, error } }
}

function updatePopup(popupDetails) {

    return dispatch => {
        dispatch(request());

        return popupService.updatePopup(popupDetails)
            .then(
                response => {
                    dispatch(success(response.data));
                    showToast(response.responseMessage, 'success');
                },
                error => {
                    dispatch(failure(error));
                    if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
                }
            );
    };

    function request() { return { type: popupConstants.UPDATE_POPUP_REQUEST } }
    function success(popups) { return { type: popupConstants.UPDATE_POPUP_SUCCESS, popups } }
    function failure(error) { return { type: popupConstants.UPDATE_POPUP_FAILURE, error } }

}

function deletePopup(popupId) {

    return dispatch => {
        dispatch(request());
        
        return popupService.deletePopup(popupId)
            .then(
                (response) => {
                    dispatch(success(popupId));
                    showToast(response.responseMessage, 'success');
                },
                error => {
                    dispatch(failure(error.toString()));
                    if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
                }
            );
    };

    function request() { return { type: popupConstants.DELETE_POPUP_REQUEST } }
    function success(id) { return { type: popupConstants.DELETE_POPUP_SUCCESS, payload: id } }
    function failure(error) { return { type: popupConstants.DELETE_POPUP_FAILURE, error } }
}